import React, { useEffect } from 'react';
import { useSurveyRoutes } from '../hooks/useSurveyRoutes';
import { makeStyles } from '~/tools/makeStyles';
import SurveyHeader from '../components/SurveyHeader';
import { fetchSurvey } from '../redux/actions';
import { useSurveyGuard } from '../hooks/useSurveyGuard';
import { usePreviewToken } from '../hooks/usePreviewToken';
import { initalizePendo } from '../telemetry/pendo';
import { useAppDispatch, useAppSelector } from '../redux/ReduxProvider';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    fontFamily: theme.typography.fontFamily,
  },
  content: {
    height: 'calc(100vh - 64px)',
  },
  errorPartial: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorMessage: {
    color: theme.palette.unfavorable,
    fontSize: 32,
    marginBottom: 16,
  },
}));

// REFACTOR: errors are re-directed to ErrorPage. Can this be integrated with
// main SurveyPage rather than being separated here?
export default function SurveyLayout({ children }) {
  const classes = useStyles();
  const { surveyCode } = useSurveyRoutes();
  const dispatch = useAppDispatch();

  const { isKiosk } = useAppSelector((state) => state.global);
  const {
    logoUrl: companyLogoUrl,
    brandColor: companyBackgroundColor,
    isLoading: companyIsLoading,
    id: companyId = 'UNKNOWN COMPANY ID',
    name: companyName = 'UNKNOWN COMPANY',
  } = useAppSelector((state) => state.company);
  const {
    isLoading: surveyIsLoading,
    isSaving: surveyIsSaving,
    isSubmitting: surveyIsSubmitting,
    isPreview,
    openSurvey,
    name: surveyName = 'UNKNOWN SURVEY NAME',
  } = useAppSelector((state) => state.survey);

  const previewTokenReady = usePreviewToken(isPreview);

  const pendoAccountData = {
    companyId,
    companyName,
    surveyName,
    isKiosk,
  };
  initalizePendo(pendoAccountData);

  // Load survey data based on route inputs.
  // NOTE: Only runs once, when component mounts.
  useEffect(() => {
    // A Shared Link survey is already loaded by its access page.
    if (!openSurvey) dispatch(fetchSurvey(surveyCode));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, surveyCode]);

  useSurveyGuard();

  const isLoading = surveyIsSubmitting || surveyIsSaving || surveyIsLoading || companyIsLoading;

  return (
    <div className={classes.root}>
      <SurveyHeader
        backgroundColor={companyBackgroundColor}
        logoUrl={companyLogoUrl}
        isLoading={isLoading}
        isKiosk={isKiosk}
        previewTokenReady={previewTokenReady}
      />
      <div className={classes.content}>{children}</div>
    </div>
  );
}
